import _ from "lodash";
import BaseFormView from "./baseFormView";
import CurationModel from "scripts/models/curationModel";
import CurationMediaModel from "scripts/models/curationMediaModel";
import templateCreateCurationForm from "templates/createCurationForm.hbs";

class CreateCurationFormView extends BaseFormView {
  get template() {
    return templateCreateCurationForm;
  }

  get events() {
    return {
      "blur form *[name]": "onBlurValidate",
      "input form *[name]": "onInputEnableSubmit",
      "submit form": "onSubmit",
      "click #bb-new-curation-form-curation-list": "onClickCurationList",
    };
  }

  constructor(options) {
    super(options);

    this.mediaModel = options.mediaModel;

    this.bindModel(new CurationModel());
  }

  render() {
    this.$el.html(
      this.template({
        maxTitleLength: this.model.maxTitleLength,
      }),
    );

    this.loaderView
      .appendTo(this.$el.find(".bb-form-submit-button-loader-region"))
      .render();

    this.enableSubmit(this.isValid());

    return this;
  }

  getMediaThumbnailUrl() {
    return (
      this.mediaModel.get("thumbnailUrl") || this.mediaModel.get("iconUrl")
    );
  }

  save() {
    this.clearErrors();

    // Set curation thumbnail to first media added thumbnail
    const data = _.merge(
      {},
      {
        thumbnailUrl: this.getMediaThumbnailUrl(),
      },
      this.toJSON(),
    );

    return this.model
      .save(data, {
        type: "POST",
      })
      .then(this.addMediaToCuration.bind(this));
  }

  addMediaToCuration(curationModel) {
    return new CurationMediaModel().save(
      {
        curation: curationModel.get("id"),
        id: this.mediaModel.get("id"),
      },
      {
        type: "POST",
      },
    );
  }

  onSubmitSucceeded() {
    this.enableSubmit(false);
    this.trigger("success", this.model.get("id"));
  }

  onClickCurationList() {
    this.trigger("curationList");
  }
}

export default CreateCurationFormView;
